import React, {useEffect, useState} from 'react';
import Layout from "@/locales/en/layout/Layout";
import BigFotoBack from "@/components/bigFotoBack/BigFotoBack";
import bg from "../../../assets/markazlar/sanoat.jpg";
import {Table, Button, Input, Tag} from 'antd';
import {SearchOutlined, DownloadOutlined, SafetyCertificateOutlined} from '@ant-design/icons';
import styled from 'styled-components';
import {initialData} from "@/pages/tuzilma/markazlar/userSertificat";

const PageWrapper = styled.div`
  padding: 40px 0;
  background-color: #f8f9fa;

  .search-card {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    border: 1px solid #eee;
  }

  .certificate-table-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    padding: 10px;
  }

  .info-block {
    margin-top: 40px;
    padding: 24px;
    background: #e7f1ff;
    border-radius: 12px;
    border-left: 5px solid #0d6efd;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .info-icon {
    font-size: 32px;
    color: #0d6efd;
  }

  @media (max-width: 768px) {
    .info-block {
      flex-direction: column;
      text-align: center;
    }
  }
`;

const M5Certificate = () => {
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        document.title = "Sertifikatlar - Sanoat xavfsizligi";
    }, []);

    const columns = [
        {
            title: '№',
            width: 60,
            align: 'center',
            render: (_, __, index) => (
                <span style={{color: '#999'}}>
            {index + 1}
        </span>
            )
        },
        {
            title: 'F.I.SH',
            dataIndex: 'fullName',
            key: 'fullName',
            sorter: (a, b) => a.fullName.localeCompare(b.fullName),
            render: (text) => <span style={{fontWeight: '600', color: '#333'}}>{text}</span>
        },
        {
            title: 'Kurs nomi',
            dataIndex: 'courseName',
            key: 'courseName',
            render: (text) => (
                <Tag color="processing" style={{borderRadius: '4px'}}>
                    {text}
                </Tag>
            )
        },
        {
            title: 'Sertifikat raqami',
            dataIndex: 'certificateNumber',
            key: 'certificateNumber',
            align: 'center',
            render: (text) => <code
                style={{background: '#f0f0f0', padding: '2px 6px', borderRadius: '4px', fontSize: '13px'}}>{text}</code>
        },
        {
            title: 'Harakat',
            align: 'center',
            render: (url) => (
                <a href={url?.url} target="_blank" rel="noopener noreferrer">
                    <Button
                        type="link"
                        icon={<DownloadOutlined/>}
                        style={{display: 'flex', alignItems: 'center', margin: '0 auto'}}
                    >
                        Yuklab olish
                    </Button>
                </a>
            ),
        },
    ];

    const filteredData = initialData.filter(item =>
        item.fullName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.certificateNumber.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <Layout>
            <BigFotoBack
                img={bg}
                text={"Sertifikatlar"}
            />

            <PageWrapper>
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-12">
                            <h2 style={{
                                fontSize: '28px',
                                fontWeight: '800',
                                marginBottom: '10px',
                                color: '#1a1a1a text-transform: uppercase'
                            }}>
                                Talabalar ro'yxati
                            </h2>
                            <p style={{color: '#666', fontSize: '16px'}}>
                                Sanoat xavfsizligi markazi tomonidan sertifikat berilgan talabalar ma'lumotlar bazasi.
                            </p>
                        </div>
                    </div>

                    <div className="search-card">
                        <div className="row align-items-center">
                            <div className="col-md-6 mb-3 mb-md-0">
                                <span style={{
                                    color: '#888',
                                    textTransform: 'uppercase',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    letterSpacing: '1px'
                                }}>
                                    Ma'lumotlar holati
                                </span>
                                <div style={{fontSize: '18px', marginTop: '5px'}}>
                                    Jami: <b style={{color: '#0d6efd'}}>{filteredData.length}</b> ta sertifikat topildi
                                </div>
                            </div>
                            <div className="col-md-6 text-md-end">
                                <Input
                                    prefix={<SearchOutlined style={{color: '#aaa'}}/>}
                                    placeholder="Ism yoki sertifikat raqami..."
                                    style={{width: '100%', maxWidth: '350px', borderRadius: '8px', height: '45px'}}
                                    allowClear
                                    onChange={e => setSearchText(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="certificate-table-wrapper">
                        <Table
                            columns={columns}
                            dataSource={filteredData.reverse()}
                            pagination={{
                                pageSize: 15,
                                position: ['bottomCenter'],
                            }}
                            scroll={{x: 800}}
                            locale={{
                                emptyText: 'Ma\'lumot topilmadi'
                            }}
                        />
                    </div>

                    <div className="info-block">
                        <div className="info-icon">
                            <SafetyCertificateOutlined/>
                        </div>
                        <div>
                            <h4 style={{margin: '0 0 5px 0', fontSize: '18px', fontWeight: '700'}}>Sertifikatni
                                haqiqiyligini tekshirish</h4>
                            <p style={{margin: 0, color: '#555'}}>
                                Har bir sertifikat o'zining takrorlanmas tartib raqamiga ega. Agar sizda shubha
                                tug'ilsa,
                                markaz xodimlari bilan bog'lanib ushbu raqam orqali tasdiqlatishingiz mumkin.
                            </p>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        </Layout>
    );
};

export default M5Certificate;
